import React, { useState, useEffect, memo } from 'react';
import { Form, Input, Select, Card, Button, Space, Row, Col, Modal, Spin, message } from 'antd';
import { useSelector } from "react-redux";
import { debounce } from "lodash";
import {
  Phone,
  Globe,
  Plus,
  X
} from 'lucide-react';
import { TbVariablePlus } from "react-icons/tb";
import { Button as ButtonMui } from "@mui/material";
import { dispatch } from "store/index";
import { AddWhatsappTemplate, FetchWhatsappChannel, FetchCreateWhatsAppSetting, PostUrlHeader, FetchAllWhatsappTemplates } from "store/action/index";
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from "react-router-dom";

const { TextArea } = Input;
const { Option } = Select;

const MediaPreview = memo(({ path }) => {
  if (!path) return null;
  return <embed src={path} width="100%" height="300px" />;
});

const WhatsAppPreview = memo(({ preview, buttons, path }) => {
  return (
    <div className="bg-gray-100 p-4 rounded-lg">
      {preview.headerText && (
        <div className="font-bold text-gray-800 mb-2">
          Character Count: {
            (preview?.headerText?.length || 0) +
            (preview?.text?.length || 0) +
            (preview?.footerText?.length || 0)
          }
        </div>
      )}
      <div className="bg-white rounded-lg shadow-sm p-4 space-y-4">
        {preview.headerText && (
          <div className="font-bold text-gray-800" style={{ fontWeight: 'bold' }}>{preview.headerText}</div>
        )}

        <MediaPreview path={path} />

        {preview?.text && (
          <div className="text-gray-700">
            {preview?.text?.split("\n")?.map((line, index) => (
              <p key={index} className="mb-2">{line}</p>
            ))}
          </div>
        )}

        {preview.footerText && (
          <div className="text-sm text-gray-500" style={{ color: "#060c1070", fontSize: "13px" }}>{preview.footerText}</div>
        )}

        {buttons.length > 0 && (
          <div className="space-y-2 d-flex flex-column pt-2 border-t">
            {buttons.map((button) => (
              <Button
                key={button.id}
                className="w-full bg-blue-600 m-1 rounded"
              >
                {button.text || `New ${button.type} Button`}
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
});

const CreateWhatsappTemplate = () => {
  const [form] = Form.useForm();
  const [buttons, setButtons] = useState([]);
  const [preview, setPreview] = useState({
    headerText: '',
    text: '',
    footerText: '',
    buttons: []
  });
  const [isVariableModalOpen, setIsVariableModalOpen] = useState(false);
  const [isVariableHModalOpen, setIsVariableHModalOpen] = useState(false);
  const [documentloading, setDocumentLoading] = useState(false);
  const [variableCount, setVariableCount] = useState(0);
  const [variableHCount, setVariableHCount] = useState(0);
  const [variableValues, setVariableValues] = useState([]);
  const [variableHValues, setVariableHValues] = useState([]);
  const [templateValues, setTemplateValues] = useState(null);
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [selectedProvider, setSelectedProvider] = useState('')
  const [selectCate, setSelectCate] = useState('')
  const navigate = useNavigate()
  const selector = useSelector((state) => state);
  const AllchannelData = selector?.AllWhatsappChannnel?.allwhatsappchannel ?? [];
  const [loadingBtn, setLoadingBtn] = useState(false)
  const activeChannels = AllchannelData?.filter(channel => channel.active == 1);
  const whatsappSettingData = selector?.AllWhatsappSettingReducer?.allWhatsappsetting?.data ?? [];
  const urlsenderTemplatess = selector?.UrlReducer?.urlsenderTemplates?.data ?? [];
  const allwhatsapptemplateData = selector?.WhatsappTemplatesReducer?.whatsappTemplates?.data ?? [];

  const buttonTypes = [
    { key: 'URL', icon: <Globe style={{ width: '14px', marginRight: '5px' }} />, label: 'Website' },
    { key: 'PHONE', icon: <Phone style={{ width: '14px', marginRight: '5px' }} />, label: 'Call Us' },
  ];
  let paramsss = { team_id: localStorage.getItem("teams_id") }

  useEffect(() => {
    dispatch(FetchCreateWhatsAppSetting({ setLoading: setIsLoading, params: paramsss }));
    dispatch(FetchWhatsappChannel({ params: paramsss }))
    let params = { per_page: "all", team_id: localStorage.getItem("teams_id") }
    dispatch(FetchAllWhatsappTemplates({ params: params }));
  }, []);

  useEffect(() => {
    if (Array.isArray(whatsappSettingData) && whatsappSettingData.length > 0) {
      const defaultProviderId = whatsappSettingData[0].id;
      handleProviderSelect(defaultProviderId);
      form.setFieldsValue({
        Provider: defaultProviderId
      });
    }
  }, [whatsappSettingData]);

  useEffect(() => {
    if (selectedChannel) {
      form.setFieldsValue({
        channelType: selectedChannel.type,
        subjectId: selectedChannel.subjectId,
        subject: selectedChannel.subject
      });
    }

    if (selectCate) {
      form.setFieldsValue({
        category: selectCate,
      });
    }
  }, [selectedChannel, selectCate]);

  useEffect(() => {
    updatePreview(form.getFieldsValue());
  }, [buttons])

  const handleChannelSelect = (channelId) => {
    const selectedChannel = activeChannels?.find(channel => channel.id === channelId);
    setSelectedChannel(selectedChannel);
  };
  const handleProviderSelect = (pro_id) => {
    setSelectedProvider(pro_id)
  }

  const handleCategorySelect = (pro_id) => {
    setSelectCate(pro_id)
  }

  const handleHeaderTypeSelect = (value) => {
    if (value) {
      form.setFieldsValue({
        header_type: value,
      });
    }
  }

  const handleNavigate = () => {
    navigate('/templates/whatsapp-templates')
  }

  const countVariables = (text) => {
    const matches = text.match(/\{\{\d+\}\}/g);
    if (!matches) return 0;
    const uniqueVariables = new Set(
      matches.map(match => match.match(/\d+/)[0])
    );
    return uniqueVariables.size;
  };

  const updatePreview = debounce((values) => {
    setPreview((prev) => ({
      ...prev,
      ...(values.headerText && { headerText: values.headerText }),
      ...(values.text && { text: values.text }),
      ...(values.footerText && { footerText: values.footerText }),
      buttons: buttons
    }));
  }, 30);

  const addButton = (type) => {
    const newButton = {
      id: buttons.length,
      type,
      text: '',
      value: ''
    };
    setButtons([...buttons, newButton]);
  };

  const removeButton = (buttonId) => {
    setButtons(buttons.filter(button => button.id !== buttonId));
    updatePreview(form.getFieldsValue());
  };

  const updateButtonField = (buttonId, field, value) => {
    const updatedButtons = buttons.map(button =>
      button.id === buttonId ? { ...button, [field]: value } : button
    );
    setButtons(updatedButtons);
    updatePreview(form.getFieldsValue());
  };

  const handleVariableModalOk = () => {
    const countHeaderTextVariable = countVariables(templateValues?.headerText || '');

    if (countHeaderTextVariable > 0) {
      setVariableHCount(countHeaderTextVariable);
      setVariableHValues(new Array(countHeaderTextVariable).fill(''));
      setIsVariableHModalOpen(true);
      return;
    }

    if (variableValues?.every(value => value?.trim())) {
      const matcherFormat = transformToMatcherFormat(templateValues, variableValues);
      setTemplateValues(matcherFormat);
      setIsVariableModalOpen(false);

      setIsLoading(true);
      dispatch(AddWhatsappTemplate({
        matcherFormat: { ...matcherFormat, provider_id: selectedProvider },
        handleNavigate,
        setIsLoading,
        params: paramsss
      }));
    } else {
      alert("Please fill in all variable values");
    }
  };

  const handleVariableHModalOk = () => {
    if (variableHValues?.every(value => value)) {
      const matcherFormat = transformToMatcherFormat(templateValues, variableValues, variableHValues[0]);
      setIsVariableModalOpen(false)
      setIsVariableHModalOpen(false);
      setIsLoading(true)
      dispatch(AddWhatsappTemplate({
        matcherFormat: { ...matcherFormat, provider_id: selectedProvider },
        handleNavigate: handleNavigate,
        setIsLoading: setIsLoading,
        params: paramsss
      }));
    } else {
      alert("Please fill in all variable values");
    }
  };

  const handleVariableHModalCancel = () => {
    setIsVariableHModalOpen(false);
  };

  const transformToMatcherFormat = (values, textExampleParams = [], headerExampleTextParam = "") => {
    const formattedButtons = buttons.map(button => {
      const baseButton = {
        text: button.text,
        buttonType: button.type
      };

      if (button.type === 'URL') {
        return {
          ...baseButton,
          url: button.value,
          urlTextExample: button.value
        };
      } else {
        return {
          ...baseButton,
          phone: button.value
        };
      }
    });
    return {
      messageMatcher: {
        name: values.name,
        channelType: values.channelType,
        language: "EN",
        content: {
          header: values?.header_type ? {
            headerType: values?.header_type,
            headerExampleTextParam: headerExampleTextParam,
            text: values.headerText,
            headerExampleMediaUrl: urlsenderTemplatess?.path
          } : undefined,
          text: values.text,
          textExampleParams: textExampleParams,
          keyboard: buttons.length > 0 ? {
            rows: [{
              buttons: formattedButtons
            }]
          } : undefined,
          footer: values.footerText ? {
            text: values.footerText
          } : undefined
        },
        category: values?.category,
        type: "OPERATOR",
        subject: values.subject,
      },
      subjectIds: [values.subjectId]
    };
  };

  const onFinish = (values) => {
    const emptyButtons = buttons.some(button => !button.text.trim() || !button.value.trim());

    if (emptyButtons) {
      Modal.error({
        title: "Validation Error",
        content: "Please fill all fields in buttons before submitting.",
      });
      return; // Stop function if any field is empty
    }

    const invalidButtons = buttons.some(button => validateInput(button));

    if (invalidButtons) {
      Modal.error({
        title: "Validation Error",
        content: "Please enter a valid URL or phone number format.",
      });
      return; // Stop execution
    }

    const count = countVariables(values?.text || '');
    setVariableCount(count);
    setVariableValues(new Array(count).fill(''));
    setTemplateValues(values);
    setIsVariableModalOpen(true);
  };

  const handleAddVariable = () => {
    const bodyText = form.getFieldValue('text');
    const count = countVariables(bodyText || '');
    if (count >= 5) {
      Modal.error({
        title: "Limit Exceeded",
        content: "You can add a maximum of 5 variables.",
      });
      return;
    }
    if (count <= 4) {
      if (!bodyText) {
        alert("Body Text cannot be empty.");
      } else {
        const matches = bodyText.match(/{{(\d+)}}/g);
        let nextNumber = 1;
        if (matches) {
          const numbers = matches.map(match => parseInt(match.match(/\d+/)[0]));
          nextNumber = Math.max(...numbers) + 1;
        }
        form.setFieldsValue({ text: `${bodyText} {{${nextNumber}}}` });
        updatePreview(form.getFieldsValue());
      }
    }
  };

  const handleAddHVariable = () => {
    const header_text = form.getFieldValue('headerText');
    const count = countVariables(header_text || '');

    if (count >= 1) {
      Modal.error({
        title: "Limit Exceeded",
        content: "You can add only 1 variable.",
      });
      return;
    }

    if (!header_text) {
      alert("Header Text cannot be empty.");
    } else {
      const nextNumber = 1;
      form.setFieldsValue({ headerText: `${header_text} {{${nextNumber}}}` });
      updatePreview(form.getFieldsValue());
    }
  };


  const handleImageUpload = async (file, onSuccess, onError) => {
    try {
      let headertyep = form.getFieldsValue("header_type")?.header_type
      if (headertyep !== "Text header") {
        let payloads = { header_type: headertyep, file: file }
        setDocumentLoading(true)
        dispatch(PostUrlHeader({ payloads: payloads, setDocumentLoading: setDocumentLoading, params: paramsss }))
      }
      onSuccess();
    } catch (error) {
      setDocumentLoading(false)
      onError(error);
    }
  }

  const renderHeaderFields = () => {
    const headerType = form.getFieldValue('header_type');
    switch (headerType) {
      case 'TEXT':
        return (
          <Form.Item
            name="headerText"
            label="Header Text"
            rules={[
              { required: true, message: "Header text is required" },
              { max: 60, message: "Maximum 60 characters allowed" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value && value.trim().length !== value.length) {
                    return Promise.reject(new Error("No spaces allowed at the beginning or end"));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input placeholder="Example: Your company" />
          </Form.Item>
        );
      case 'IMAGE':
        return (
          <Spin spinning={documentloading}>
            <Form.Item name="Header Image" label="Header Image">
              <Upload
                customRequest={({ file, onSuccess, onError }) =>
                  handleImageUpload(file, onSuccess, onError)
                }
                listType="picture"
                maxCount={1}
                accept=".jpeg,.jpg,.png"
                beforeUpload={(file) => {
                  const isLt1M = file.size / 1024 / 1024 < 1; // Convert bytes to MB
                  if (!isLt1M) {
                    Modal.error({
                      title: "File Size Exceeded",
                      content: "Image size must be less than 1MB.",
                    });
                    return Upload.LIST_IGNORE; // Ignore file upload
                  }
                  return true;
                }}
              >
                <Button icon={<UploadOutlined />}>Upload Image</Button>
              </Upload>
            </Form.Item>
          </Spin>
        );
      case 'DOCUMENT':
        return (
          <Spin spinning={documentloading}>
            <Form.Item name="Header File" label="Header File">
              <Upload
                customRequest={({ file, onSuccess, onError }) =>
                  handleImageUpload(file, onSuccess, onError)
                }
                listType="text"
                maxCount={1}
                accept=".pdf"
                beforeUpload={(file) => {
                  const isLt2M = file.size / 1024 / 1024 < 2; // Convert bytes to MB
                  if (!isLt2M) {
                    Modal.error({
                      title: "File Size Exceeded",
                      content: "File size must be less than 2MB.",
                    });
                    return Upload.LIST_IGNORE; // Prevents file from being uploaded
                  }
                  return true;
                }}
              >
                <Button icon={<UploadOutlined />}>Upload File</Button>
              </Upload>
            </Form.Item>
          </Spin>
        );
      case 'VIDEO':
        return (
          <Spin spinning={documentloading}>
            <Form.Item name="Header Video" label="Header Video">
              <Upload
                customRequest={({ file, onSuccess, onError }) =>
                  handleImageUpload(file, onSuccess, onError)
                }
                listType="text"
                maxCount={1}
                accept=".mp4,.3gp"
                beforeUpload={(file) => {
                  const isLt2M = file.size / 1024 / 1024 < 2; // Convert bytes to MB
                  if (!isLt2M) {
                    Modal.error({
                      title: "File Size Exceeded",
                      content: "Video size must be less than 2MB.",
                    });
                    return Upload.LIST_IGNORE; // Prevents file from being uploaded
                  }
                  return true;
                }}
              >
                <Button icon={<UploadOutlined />}>Upload Video</Button>
              </Upload>
            </Form.Item>
          </Spin>
        );
      default:
        return null;
    }
  };

  const validateInput = (button) => {
    if (button.type === 'URL') {
      const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+\/?)([^\s]*)$/;
      return urlPattern.test(button.value) ? "" : "Invalid URL format";
    } else if (button.type === 'PHONE') {
      const phonePattern = /^\+92\d{10}$/;
      return phonePattern.test(button.value) ? "" : "Invalid phone number format (+92XXXXXXXXXX)";
    }
    return "";
  };


  return (
    <>
      <Spin spinning={isLoading}>
        <Row gutter={[16, 24]} className="p-4">
          <Col xs={24} sm={14}>
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              onValuesChange={updatePreview}
              initialValues={{
                channelType: 'WHATSAPP'
              }}
            >
              <Card className="mb-4">
                <Form.Item
                  name="name"
                  label="Template Name"
                  tooltip="Only lowercase letters, numbers, and '_' are allowed. No spaces or capital letters."
                  rules={[
                    { required: true, message: "Template name is required!" },
                    { pattern: /^[a-z0-9_]+$/, message: "Only lowercase letters, numbers, and '_' are allowed. No spaces or capital letters." },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value) return Promise.resolve(); // Agar value empty hai to required rule handle karega

                        // Duplicate check
                        const isDuplicate =
                          Array.isArray(allwhatsapptemplateData) &&
                          allwhatsapptemplateData.length !== 0 &&
                          allwhatsapptemplateData.some((template) => template.name == value);

                        if (isDuplicate) {
                          return Promise.reject("This template name already exists!");
                        }

                        // Length validation (max 60 characters)
                        if (value?.length > 60) {
                          return Promise.reject("Template name cannot exceed 60 characters!");
                        }

                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input placeholder="Enter template name" />
                </Form.Item>

                <Form.Item
                  name="channel"
                  label="Select Channel"
                  rules={[{ required: true, message: 'Please select a channel' }]}
                >
                  <Select
                    placeholder="Select a channel"
                    onChange={handleChannelSelect}
                  >
                    {Array.isArray(activeChannels) && activeChannels.length !== 0 && activeChannels?.map((channel) => (
                      <Option key={channel.id} value={channel.id}>
                        {channel.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="Provider"
                  label="Select Provider"
                  rules={[{ required: true, message: 'Please select a Provider' }]}
                >
                  <Select
                    placeholder="Select a Provider"
                    onChange={handleProviderSelect}
                    value={selectedProvider}
                  >
                    {Array.isArray(whatsappSettingData) && whatsappSettingData.length !== 0 && whatsappSettingData?.map((channel) => (
                      <Option key={channel.id} value={channel.id}>
                        {channel.sender_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>


                <Form.Item
                  name="category"
                  label="Select Category"
                  rules={[{ required: true, message: 'Please select a Category' }]}
                >
                  <Select
                    placeholder="Select a Category"
                    onChange={handleCategorySelect}
                  >
                    <Option value="UTILITY">Utility</Option>
                    <Option value="AUTHENTICATION">Authentication</Option>
                    <Option value="MARKETING">Marketing</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name="header_type"
                  label="Select Header Type"
                >
                  <Select
                    placeholder="Select a Header Type"
                    onChange={handleHeaderTypeSelect}
                  >
                    <Option value="TEXT">Text header</Option>
                    <Option value="IMAGE">Image header</Option>
                    <Option value="DOCUMENT">file header</Option>
                    <Option value="VIDEO">video header</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name="channelType"
                  label="Channel Type"
                  hidden
                >
                  <Input disabled />
                </Form.Item>

                <Form.Item
                  name="subject"
                  label="Subject"
                  hidden
                >
                  <Input disabled />
                </Form.Item>

                <Form.Item
                  name="subjectId"
                  label="Subject ID"
                  hidden
                >
                  <Input disabled />
                </Form.Item>
              </Card>

              <Card title="Message Content" className="mb-4">
                {renderHeaderFields()}

                {form.getFieldValue('header_type') == "TEXT" ? <ButtonMui
                  onClick={handleAddHVariable}
                  title="Add Variable in Header Text"
                  variant="contained"
                  className="my-2"
                >
                  <TbVariablePlus />
                </ButtonMui> : <></>}

                <Form.Item
                  name="text"
                  label="Body Text"
                  rules={[{ required: true }]}
                >
                  <TextArea
                    rows={4}
                    placeholder="Example: Hello, {{1}}! Thanks for choosing {{2}}"
                  />
                </Form.Item>
                <ButtonMui
                  onClick={handleAddVariable}
                  title="Add Variable in Body"
                  variant="contained"
                  className="my-2"
                >
                  <TbVariablePlus />
                </ButtonMui>

                <Form.Item
                  name="footerText"
                  label="Signature"
                  rules={[
                    { required: true, message: "Signature is required" },
                    { max: 60, message: "Maximum 60 characters allowed" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (value && (value.trim().length !== value.length)) {
                          return Promise.reject(new Error("No spaces allowed at the beginning or end"));
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input placeholder="Add a footer note" />
                </Form.Item>

              </Card>

              <Card title="Buttons" className="mb-4">
                <div className="grid grid-cols-12 gap-2 mb-4 d-flex justify-content-center">
                  {buttonTypes.map(({ key, icon, label }) => (
                    <Button
                      key={key}
                      onClick={() => addButton(key)}
                      className="text-left grid-cols-12 flex items-center m-1 gap-4"
                      disabled={buttons.length >= 3}
                      style={{ width: '45%' }}
                    >
                      {icon}
                      <span className="pl-4">{label}</span>
                    </Button>
                  ))}
                </div>

                <Space direction="vertical" className="w-full">
                  {buttons.map((button) => (
                    <Card
                      key={button.id}
                      size="small"
                      className="w-full"
                      title={button.type === 'URL' ? "Link" : "Phone"}
                      extra={
                        <Button
                          type="text"
                          onClick={() => removeButton(button.id)}
                          className="p-0"
                        >
                          <X className="h-4 w-4" />
                        </Button>
                      }
                    >
                      <div className="space-y-4">
                        <Input
                          placeholder="Button Text"
                          value={button.text}
                          maxLength={25}
                          onChange={(e) => updateButtonField(button.id, 'text', e.target.value)}
                        />

                        <Input
                          placeholder={button.type === 'URL' ? 'Website URL' : '+92 1234567890 (must be in this format)'}
                          value={button.value}
                          onChange={(e) => updateButtonField(button.id, 'value', e.target.value)}
                          className="mt-2"
                          type={button.type === 'URL' ? 'url' : 'text'}
                        />
                        {validateInput(button) && <span style={{ color: "red" }}>{validateInput(button)}</span>}
                      </div>
                    </Card>
                  ))}
                </Space>
              </Card>

              <Button type="primary" htmlType="submit" className="w-full" loading={loadingBtn} >
                Save Template
              </Button>
            </Form>
          </Col>

          <Col xs={24} sm={10}>
            <Card title="Template Preview">
              <WhatsAppPreview
                preview={preview}
                buttons={buttons}
                path={urlsenderTemplatess?.path}
              />
            </Card>
          </Col>
        </Row>
      </Spin >

      <Modal
        title="Enter Variable Values Body"
        open={isVariableModalOpen}
        closable={false}
        footer={
          variableValues?.every(value => value?.trim() !== "") ? (
            <Button key="submit" type="primary" onClick={handleVariableModalOk}>
              OK
            </Button>
          ) : null
        }
      >
        <div className="space-y-4">
          <p>Found {variableCount} variables in your template. Please provide values for each:</p>
          {Array.from({ length: variableCount })?.map((_, index) => (
            <Form.Item key={index} label={`Variable ${index + 1}`} className="mb-4">
              <Input
                placeholder={`Enter value for variable ${index + 1}`}
                value={variableValues[index]}
                onChange={(e) => {
                  const newValues = [...variableValues];
                  newValues[index] = e.target.value;
                  setVariableValues(newValues);
                }}
              />
            </Form.Item>
          ))}
        </div>
      </Modal>


      <Modal
        title="Enter Variable Values Header Text"
        open={isVariableHModalOpen}
        closable={false}
        footer={
          variableHValues?.every(value => value?.trim() !== "") ? (
            <Button key="submit" type="primary" onClick={handleVariableHModalOk}>
              OK
            </Button>
          ) : null
        }
      >
        <div className="space-y-4">
          <p>Found {variableHCount} variables in your template. Please provide values for each:</p>
          {Array.from({ length: variableHCount })?.map((_, index) => (
            <Form.Item key={index} label={`Variable ${index + 1}`} className="mb-4">
              <Input
                placeholder={`Enter value for variable ${index + 1}`}
                value={variableHValues[index]}
                onChange={(e) => {
                  const newValues = [...variableHValues];
                  newValues[index] = e.target.value;
                  setVariableHValues(newValues);
                }}
              />
            </Form.Item>
          ))}
        </div>
      </Modal>

    </>
  );
};

export default CreateWhatsappTemplate;